<template>
  <div class="i-group-coaching">
    <iJCAHero
      @open-jca-resources="openJCAResources"
      @scroll-to-jca-intro="scrollTo('#jca-intro')"
    />
    <iJCAJoin />
    <iJCACoachUpsell />
    <iJCAIntro id="jca-intro" />
    <iBaseButton
      v-bind="BUTTON_STYLE"
      text="Browse Past Sessions & Tools"
      @clicked="openJCAResources"
    />
    <iJCASteps />
  </div>
</template>

<script setup lang="ts">
import { breakpointLg } from "@/styles/variables"

import useIsScreenSize from "@/composables/useIsScreenSize"

// ASSETS
import iconArrowRight from "@/assets/icons/icon-arrow-right-white.svg"

// COMPONENTS
import iBaseButton from "@/components/base/BaseButton.vue"
import iJCAJoin from "@/components/report/groupCoaching/JCAJoin.vue"
import iJCAHero from "@/components/report/groupCoaching/JCAHero.vue"
import iJCACoachUpsell from "@/components/report/groupCoaching/JCACoachUpsell.vue"
import iJCAIntro from "@/components/report/groupCoaching/JCAIntro.vue"
import iJCASteps from "@/components/report/groupCoaching/JCASteps.vue"
import { GlobalVariables } from "@/helpers/globalVariables"
import { white } from "@/styles/colors"

// CONSTANTS
const BUTTON_STYLE = {
  size: "medium",
  fontWeight: "500",
  width: "fit-content",
  backgroundImage: "linear-gradient(to right, #9810FA, #155DFC)",
  borderRadius: "12px",
  textColor: white,
  text: "Learn More",
  iconUrl: iconArrowRight
}

// COMPOSABLES
const isLgOrLarger = useIsScreenSize(breakpointLg)

// FUNCTIONS
const openJCAResources = () => {
  window.open(GlobalVariables.careerAcceleratorResourcesLink, "_blank")
}

const scrollTo = (section: string) => {
  const sectionElement = document.querySelector(section)

  if (!sectionElement) return

  // Calculate the target scroll position and scroll to
  const targetScrollPosition =
    sectionElement.getBoundingClientRect().top + window.scrollY - (isLgOrLarger.value ? 90 : 28)
  window.scrollTo({ top: targetScrollPosition, behavior: "smooth" })
}
</script>

<style scoped lang="scss">
.i-group-coaching {
  @include flex(column, start, center, $gap: 60px);

  @media screen and (min-width: $breakpoint-md) {
    gap: 80px;
  }
}
</style>
